import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { CustomerAdminRow } from '../_models/customer';
import { VehiclesFilesService } from '../_services/vehicles-files.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { catchError, finalize } from 'rxjs/operators';
import { IVehicleActivityRow, IVehicleActivityApiParams, IPaginatedVehicleActivityRow } from '../_models/vehicle-file';
import { Subscription } from 'rxjs';
import { of } from 'rxjs/observable/of';


export class VehicleFileDataSource implements DataSource<IVehicleActivityRow> {

    public vehicleFileSubject$ = new BehaviorSubject<IVehicleActivityRow[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    public paginatorTotalCount: number;

    private currentRequest: Subscription;

    constructor(
        private vehicleService: VehiclesFilesService
    ) {
    }

    loadVehicleActivities(params: IVehicleActivityApiParams) {
        if (this.currentRequest) {
            this.currentRequest.unsubscribe();
            this.currentRequest = null;
        }

        this.loadingSubject.next(true);

        this.currentRequest = this.vehicleService.getVehicleActivities(params).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe((vehicles: IPaginatedVehicleActivityRow) => {
            const _count: number = vehicles.count;
            this.paginatorTotalCount = _count || 0;
            this.vehicleFileSubject$.next(vehicles.results as IVehicleActivityRow[]);
            // console.log('Subject: ', this.vehicleFileSubject$);
        });

    }

    connect(collectionViewer: CollectionViewer): Observable<IVehicleActivityRow[]> {
        return this.vehicleFileSubject$.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.vehicleFileSubject$.complete();
        this.loadingSubject.complete();
    }

}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_datasources/vehicle-file.datasource.ts